import type { CampaignDayCardStep } from '@poseidon/components/CampaignDayCard';
import { CampaignDayCardPure } from '@poseidon/components/CampaignDayCard';

import { useSequenceTimeline } from '~/components/Sequence/sequenceTimelineContext';

interface Props {
  date: Date;
  steps: CampaignDayCardStep[];
}

/**
 * One day of a contact's sequence, drawn by the campaign's own day card in its text-only mode: rows open the
 * campaign inline editor (subject / body — this contact's copy), a to-do waiting on the rep offers Mark done,
 * and there is no add / delete / finish / skip, because the day's shape belongs to the sequence template.
 * The day card's structural callbacks are unreachable in that mode; the no-ops below satisfy its contract.
 */
export function SequenceTimelineDay({ date, steps }: Props) {
  const { editingKey, onEdit, onCancelEdit, onSave, onMarkDone, variables, documents } = useSequenceTimeline();
  const markDone = (stepId: string) => {
    const type = steps.find((s) => s.id === stepId)?.type;
    if (type != null) onMarkDone(stepId, type);
  };
  return (
    <CampaignDayCardPure
      contentOnly
      date={date}
      now={undefined}
      steps={steps}
      isDifferentFromTemplate={false}
      isPickingStepType={false}
      editingStepId={editingKey ?? undefined}
      addingStepType={undefined}
      disabledStepReasons={undefined}
      variables={variables}
      documents={documents}
      onEditStep={onEdit}
      onSaveStep={onSave}
      onCancelEditStep={onCancelEdit}
      // Only the row's Mark done reaches this in text-only mode (the editor's finish / skip are hidden).
      onResolveStep={markDone}
      onMarkCallStepDone={({ cadenceStepId }) => markDone(cadenceStepId)}
      stepHistoryOptions={undefined}
      templateHref={undefined}
      onDeleteStep={() => undefined}
      onAddStep={() => undefined}
      onPickStepType={() => undefined}
      onCancelPickStepType={() => undefined}
      onSaveNewStep={() => undefined}
      onCancelAddStep={() => undefined}
      renderSiftConditionBuilder={() => null}
      onCreateReminder={() => Promise.resolve()}
      onReminderError={() => undefined}
      reminderActions={undefined}
      reminderActionsLoading={undefined}
      reminderCreating={undefined}
    />
  );
}
